export default __webpack_public_path__ + "static/resale-0f108050f5413a68605508351e6c461e.png";